import { Controller } from "@hotwired/stimulus"

// Контроллер для показа/скрытия и копирования API-ключа
export default class extends Controller {
  static targets = ["masked", "revealed", "toggleBtn"]

  toggle() {
    if (!this.hasMaskedTarget || !this.hasRevealedTarget) return

    const maskedHidden = this.maskedTarget.classList.contains("hidden")
    if (maskedHidden) {
      // Скрыть ключ
      this.maskedTarget.classList.remove("hidden")
      this.revealedTarget.classList.add("hidden")
    } else {
      // Показать ключ
      this.maskedTarget.classList.add("hidden")
      this.revealedTarget.classList.remove("hidden")
    }
  }

  async copy() {
    const key = this.hasRevealedTarget
      ? this.revealedTarget.dataset.keyValue
      : null

    if (!key) return

    try {
      await navigator.clipboard.writeText(key)

      // Визуальная обратная связь
      const btn = this.element.querySelector('[title="Копировать ключ"]')
      if (btn) {
        const originalTitle = btn.title
        btn.title = "Скопировано!"
        setTimeout(() => { btn.title = originalTitle }, 2000)
      }
    } catch (err) {
      console.warn("[api-key-reveal] clipboard write failed:", err)
    }
  }
}
